import { LinkInterface } from '@teko/types/ds';
import { MegaMenuItemInterface } from '@teko/types/pb';
import { computeBlockPageUrl } from './common';
import { MenuItem, MenuItemBanner } from '@teko/discovery';

export const convertUrl = (
  targetPath: string,
  urlType: string,
  isTargetBlank?: boolean,
): LinkInterface => {
  if (!targetPath) return;
  if (urlType === 'rewrite') {
    return {
      href: '/search?router=productListing&' + targetPath,
      target: isTargetBlank ? '_blank' : '_self',
    };
  }
  return {
    href: targetPath,
    target: isTargetBlank ? '_blank' : '_self',
  };
};

export const convertMegaMenuItem = (item: MenuItem): MegaMenuItemInterface => {
  return {
    name: item.name,
    icon: item.icon,
    link:
      computeBlockPageUrl(item) ||
      convertUrl(item.targetPath, item.urlType, item.isTargetBlank),
    banner: !!item.banners?.length
      ? {
          src: item.banners[0]?.image,
          hoverEffect: 'zoom',
          link: convertUrl(
            item.banners[0]?.targetPath,
            item.banners[0]?.urlType,
          ),
        }
      : null,
    children: item.children.map(convertMegaMenuItem),
  };
};

const getValidBanners = (banners: MenuItemBanner[]) => {
  return banners.filter((banner) => {
    if (!banner.isActive) return false;
    const currentTime = new Date().getTime();
    if (banner?.startDate || banner?.endDate) {
      if (!banner?.startDate) {
        return currentTime <= banner.endDate * 1000;
      }
      if (!banner?.endDate) {
        return currentTime >= banner.startDate * 1000;
      }
      return (
        banner.startDate * 1000 <= currentTime &&
        banner.endDate * 1000 >= currentTime
      );
    }
    return true;
  });
};

export const buildTreeCategories = (menuItems: MenuItem[]): MenuItem[] => {
  const rootMenuItems = menuItems.filter(({ parentId }) => !parentId);
  const buildMenuItem = (root: MenuItem): MenuItem => {
    const children = menuItems.filter(({ parentId }) => parentId === root.id);
    return {
      ...root,
      banners: getValidBanners(root.banners || []),
      children: children.map(buildMenuItem),
    };
  };
  return rootMenuItems.map((root) => buildMenuItem(root));
};
